import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { setULSearchText } from "../../../store/templateList";
import { selectULSearchText } from "../../../store/templateList/selectors/selectULSearchText";

export const FileTemplateSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectULSearchText);

  return (
    <IonSearchbar
      value={searchText}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setULSearchText(value));
      }}
      debounce={700}
      placeholder={"Buscar plantilla..."}
    />
  );
};
